import { Link } from "react-router-dom";

const LINKS = [
  { label: "Money Flow", href: "#money-flow" },
  { label: "Privacy", href: "#privacy" },
  { label: "Apps", href: "#apps" },
  { label: "Features", href: "#features" },
];

export function LandingFooter() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 px-6 py-10 lg:flex-row lg:px-10">
        <div className="flex items-center gap-2.5">
          <span className="h-3 w-3 rounded-full bg-primary" />
          <span className="text-base font-bold text-foreground">Budge<span className="text-primary-text">AI</span></span>
          <span className="text-sm text-muted-foreground">· Understand your money</span>
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">{l.label}</a>
          ))}
          <Link to="/auth" className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">Log in</Link>
        </nav>
      </div>
    </footer>
  );
}
